import { get } from "./../api";

type Response = {
	data: {
		grid: any;
	};
};

export function getCurrentCatalog(id: string, params: string) {
	return get<Response>("/api/v1/shop/catalog/get/" + id + "?" + params);
}
